document.addEventListener('DOMContentLoaded', function() {
    
    function addWrapperWithRetries(retries, delay) {
        setTimeout(() => {
            var container = document.querySelector('.moose-container .faq_bold-header'); 
            var heading = document.querySelector('.moose-container .faq_bold-header .faq_bold-header-heading.md-font-unix');
            var subheading = document.querySelector('.moose-container .faq_bold-header .faq_bold-header-subheading.md-font-unix');
            var searchForm = document.querySelector('.moose-container .faq_bold-header .faq_bold-header-search');
            
            if (heading && subheading && searchForm && container) {
                var wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('wrapper-class');
                
                wrapperDiv.appendChild(heading);
                wrapperDiv.appendChild(subheading);
                wrapperDiv.appendChild(searchForm);
                
                container.appendChild(wrapperDiv);
                console.log("Wrapper added successfully");
            } else if (retries > 0) {
                console.log("Retrying to add wrapper...");
                addWrapperWithRetries(retries - 1, delay);
            } else {
                console.log("Failed to add wrapper after multiple retries.");
            }
        }, delay);
    }
    addWrapperWithRetries(10, 300);
});
